export class Country {
  private readonly data: {
    callingCode: string | null;
    countryCode: string;
    countryName: string;
    defaultCurrency: string;
    minCoppaAge: string;
    sorting: string | null;
  };

  constructor(data: any) {
    this.data = data;
  }

  public get code(): string {
    return this.data.countryCode;
  }

  public get name(): string {
    return this.data.countryName;
  }

  public get callingCode(): string {
    return this.data.callingCode;
  }
}
